'use client';

import { createContext, PropsWithChildren, useContext, useMemo } from 'react';
import { useImmer } from 'use-immer';

interface AppLayoutContextData {
  appLayoutContent: AppLayoutContent | null;
  wasSplashScreenClosed: boolean;
  handleCloseSplashScreen(): void;
}

const AppLayoutContext = createContext({} as AppLayoutContextData);

interface Props extends PropsWithChildren {
  appLayoutContent: AppLayoutContent;
}

export type AppLayoutContextProviderProps = Props;

export const AppLayoutContextProvider = (props: Props) => {
  const { appLayoutContent, children } = props;

  const [wasSplashScreenClosed, setWasSplashScreenClosed] = useImmer(false);

  const handleCloseSplashScreen = () => {
    setWasSplashScreenClosed(true);
  };

  const value = useMemo(() => {
    return {
      appLayoutContent,
      wasSplashScreenClosed,
      handleCloseSplashScreen,
    };
  }, [appLayoutContent, wasSplashScreenClosed]);

  return (
    <AppLayoutContext.Provider value={value}>
      {children}
    </AppLayoutContext.Provider>
  );
};

export const useAppLayoutContent = () => useContext(AppLayoutContext);
